import VectorService from "@/services/vector.service";
import CustomControl from "./custom-control";
import globalModule from "@/store/modules/global.module";

export default class RasterControl extends CustomControl {
    constructor() {
        super(RasterControl.buildHtml());
    }

    addEvents(element: HTMLElement): void {
        element.querySelector('button')!.addEventListener('click', () => {
            const rasterActive = globalModule.rasterActive
            globalModule.setRaster(!rasterActive)
        }, false)

    }

    static buildHtml() {
        const element = document.createElement('div')
        element.className = 'ol-control raster-control'
        const button = document.createElement('button')
        button.id = 'raster-control'
        button.innerHTML = `
            <img src="${require('@/assets/img/raster.png')}">
        `
        element.appendChild(button)
        return element
    }

}